module.exports = __webpack_public_path__ + "img/help.709e1c60.png";